<template>
	<div class="choice-component" v-if="data.type=='choice'">
		<p class="choice-title">
			<span>{{data.id}}.</span>
			{{data.text}} ({{data.score}}分)
		</p>
		<div class="choice-option" :class="{error: empty()}">
			<a
					v-for="(option,index) in data.children"
					:key="index"
					:class="{active: active(option.key), error: error(option.key), isAnswer: isAnswer(option.key)}"
					@click="change(option.key)"
			>
				<i></i>
				<span>{{getFlag(index)}}. {{option.text}}</span>
			</a>
		</div>
	</div>
</template>

<script>
    // 引入mixins
    import mixins_config from "@/mixins/config.js";
    
	
    export default {
        name: "ChoiceComponent",
        mixins: [mixins_config],
        components: {},
        props: {
            data: {
                type: Object,
                required: true,
			}
        },
        methods: {
            // 值改变
            change(key) {
                let that = this;
                if (that.disabled) {
                    return
                }
                // 单选
                that.submits[that.data.key] = key;
            },
			
            // 是否选中
            active(key) {
                if (!this.showSubmits) {
                    return false
                }
                return this.submits && this.submits[this.data.key] && this.submits[this.data.key] === key
            },

            // 当前作答是否正确
            correct(key) {
                return this.data.answers && this.data.answers.indexOf(key) >= 0
            },

            // 选项是否错误
            error(key) {
                if (!this.showErrors) {
                    return false
                }
                return !this.correct(key)
            },

            // 是否未作答
            empty() {
                if (!this.showErrors) {
                    return false
                }
                return this.submits && !this.submits[this.data.key]
            },
			
			// 是否是题目的答案
			isAnswer(key) {
                if (!this.showAnswers && !this.showErrors) {
                    return false;
				}
                if (!this.showAnswers && this.showErrors) {
                    // 只显示作答的正确情况，不显示正确答案
					if (key !== this.submits[this.data.key]) {
					    return false;
					}
				}
                return this.correct(key)
			},

			// 获得选项序号
            getFlag(index) {
                let flags = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L'];
                return flags[index]
            },

        }
    };
</script>

<style lang="scss" scoped>
	// active 当前选中
	
	// 是正确答案
	.choice-option .isAnswer {
		i {
			border: 5px solid #1890ff;
		}
		
		span {
			color: #1890ff;
		}
	}
	
	// 答对的答案
	.active.isAnswer  {
		i {
			border: 5px solid #33cc33;
		}
		
		span {
			color: #33cc33;
		}
	}
	
	// 答错的答案
	.choice-option.error {
		border-color: red;
	}
	.active.error {
		i {
			border: 5px solid red;
		}
		
		span {
			color: red;
		}
	}
	
	
</style>
